import React, { useEffect } from 'react'
import './style.css'
import { NavLink, useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { handleLogout } from '../../../redux/slices/authSlice'
import { getUnreadNotificationCount } from '../../../redux/actions/notification'

const SampleDashboardBar = () => {

    const dispatch = useDispatch();
    // const user = useSelector(state => state.AuthSlice.user)
    const user = useSelector((state) => state?.AuthSlice?.user);
    const unreadCount = useSelector((state) => state?.notificaions?.unreadCount);
    const isDisabled = user?.subscription?.status !== 'active' && user?.subscription?.status !== 'cancelled';
    const navigate = useNavigate()

    useEffect(() => {
        if (user?.id) {
            dispatch(getUnreadNotificationCount(user?.id));
        }
    }, [user?.id]);
    const handleLogoutHere = async () => {
        const res = await dispatch(handleLogout())
        navigate("/signin");
    }

    return (
        <>
            <ul className="corporate-sidebar sample-sidebar-topBar">
                <li>
                    <NavLink
                        to="/user/chat"
                        className={({ isActive }) =>
                            isActive
                                ? 'active-link'
                                : isDisabled
                                    ? 'disable-btn'
                                    : ''
                        }
                    >
                        <i className="fa-regular fa-comment"></i> Chat
                    </NavLink>
                </li>

                <li>
                    <NavLink to="/user/profile" className={({ isActive }) =>
                        isActive
                            ? 'active-link'
                            : ''
                    }><i className="fa-regular fa-user"></i> My Profile</NavLink>
                </li>

                <li>
                    <NavLink to="/user/availed/services" className={({ isActive }) =>
                        isActive
                            ? 'active-link'
                            : isDisabled
                                ? 'disable-btn'
                                : ''
                    }><i className="fa-solid fa-star"></i> Availed Services</NavLink>
                </li>

                <li>
                    <NavLink to='/user/subscriptions' className={({ isActive }) => isActive ? 'active-link' : ''}><i className="fa-solid fa-gear"></i> Subscripiton</NavLink>
                </li>

                <li>
                    <NavLink to='/user/settings' className={({ isActive }) =>
                        isActive
                            ? 'active-link'
                            : ''
                    }><i className="fa-solid fa-gear"></i> Settings</NavLink>
                </li>

                <li>
                    <NavLink to='/user/notificaitons' className={({ isActive }) =>
                        isActive
                            ? 'active-link'
                            : isDisabled
                                ? 'disable-btn'
                                : ''
                    }>
                        <i className="fa-regular fa-bell"></i> Notifications
                        {unreadCount > 0 && (
                            <span className="notification-badge">{unreadCount > 99 ? '99+' : unreadCount}</span>
                        )}
                    </NavLink>
                </li>

                {/* <li>
                    <NavLink to='/' className={({ isActive }) =>
                            isActive
                                ? 'active-link'
                                : isDisabled
                                    ? 'disable-btn'
                                    : ''
                        }><i className="fa-solid fa-right-from-bracket"></i>Logout</NavLink>
                </li> */}

                <li>
                    <a style={{ cursor: 'pointer' }} onClick={handleLogoutHere}><i className="fa-solid fa-right-from-bracket"></i>Logout</a>
                </li>
            </ul>
        </>
    )
}

export default SampleDashboardBar